import type { PollResultOptionAllOf } from './pollResultOptionAllOf';
import type { PollResultOptionAllOfTwo } from './pollResultOptionAllOfTwo';

export type PollResultOption = PollResultOptionAllOf & PollResultOptionAllOfTwo;
